import React from 'react';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

class AgendaColumnHeader extends React.Component {
  render() {
    return (
      <GenericTooltip positionTop delay={TOOLTIP_DELAY} tooltip={this.props.popoverMessage}>
        <h4 className="column-header">{this.props.title}</h4>
      </GenericTooltip>
    );
  }
}

export default AgendaColumnHeader;
